import { render, staticRenderFns } from "./ScheduleVideosRecord.vue?vue&type=template&id=227259f6&"
import script from "./ScheduleVideosRecord.vue?vue&type=script&lang=js&"
export * from "./ScheduleVideosRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports